import React, { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import FacilityManagement from '.';
import './FacilityManagement.css';
import CustomTabListView from '../../components/common/CustomTabListView';

const FacilityTabs = (props: any) => {
  const { tabs = [] } = props;

  return (
    <div className="facility-management">
      <CustomTabListView {...props} id={'facility-management-tabs'}>
        {tabs.map((list: string) => {
          return (
            <Tab key={list} eventKey={list} title={list}>
              {list === 'Health Facility Maintenance' && <FacilityManagement />}
            </Tab>
          );
        })}
      </CustomTabListView>
    </div>
  );
};
export default FacilityTabs;
